import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { OrderLink } from './idLink';

const journeyBrokenRenderer = ({ changes: { shipper_order_broken_id }, ...props }) => {
  return (
    <Spacer {...props}>
      {!!shipper_order_broken_id && (
        <Text color="grey800" display="block">
          <OrderLink id={shipper_order_broken_id} />
          removed
        </Text>
      )}
    </Spacer>
  );
};

export default journeyBrokenRenderer;
